/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from '@vlinder-web/plugin-agent-service-react';
import {
  FeatureAboutMePlugin,
  IFeatureAboutMePluginMethods,
  FooterAboutMePlugin,
  IFooterAboutMePluginMethods,
  HeaderAboutMePlugin,
  IHeaderAboutMePluginMethods,
  StaticPageAboutMePlugin,
  IStaticPageAboutMePluginMethods,
  ErrorContentPlugin,
  IErrorContentPluginMethods,
  LoadingAboutMePlugin,
  ILoadingAboutMePluginMethods,
} from './plugins';
import { featureAboutMeConfig } from '../config/featuresSection.config';

export type TAgent = IFeatureAboutMePluginMethods &
  IFooterAboutMePluginMethods &
  IHeaderAboutMePluginMethods &
  IStaticPageAboutMePluginMethods &
  IErrorContentPluginMethods &
  ILoadingAboutMePluginMethods;

const getPlugins = () => {
  return [
    new StaticPageAboutMePlugin(),
    new ErrorContentPlugin(),
    new LoadingAboutMePlugin(),
    //Business logic plugins !
    new FeatureAboutMePlugin(),
    new HeaderAboutMePlugin(),
    new FooterAboutMePlugin(),
  ];
};

export const getAgent = () => {
  return createAgent<TAgent>({
    plugins: getPlugins(),
  });
};
